module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "similar_rooms"
  }, [_c('div', {
    staticClass: "main_title t_style5 l_blue s_title a_left"
  }, [_c('div', {
    staticClass: "c_inner"
  }, [_c('h2', {
    staticClass: "c_title"
  }, [_vm._v("SIMILAR ROOMS")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('article', [_c('figure', [_c('a', {
    staticClass: "hover_effect h_blue h_link",
    attrs: {
      "href": "room.html"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/rooms/single-room.jpg",
      "alt": "Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("€99"), _c('span', [_vm._v(" night")])]), _vm._v(" "), _c('figcaption', [_c('h4', [_c('a', {
    attrs: {
      "href": "room.html"
    }
  }, [_vm._v("Double Room")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69dc64b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/singleRoom/sections/similarRooms.vue
// module id = 377
// module chunks = 0